import {
    PromoCodeRequest,
    RestDataResponsePromoCodeValidationResult,
    validatePost,
} from '@cecm-microservices-sdk/core/services/offers/promocode/validate';
import { getMicroservicesClient } from '@/services/microservices/client';
import type { MicroservicesCountryCode } from './usedCarEligibility';

export async function submitPromoCodeValidationRequest(
    countryCode: MicroservicesCountryCode,
    payload: PromoCodeRequest,
): Promise<RestDataResponsePromoCodeValidationResult> {
    const client = getMicroservicesClient(countryCode);

    if (!client.baseUrl) {
        throw new Error(
            `Missing microservices base URL for ${countryCode.toUpperCase()}. Check the runtime configuration for the active environment.`,
        );
    }

    return validatePost(client, payload);
}
